/* eslint-disable camelcase */
// import { useState } from 'react';
// import { Icon } from 'react-icons-kit';
// import { ic_view_list } from 'react-icons-kit/md/ic_view_list';
// import { ic_chevron_right } from 'react-icons-kit/md/ic_chevron_right';
// import { ic_expand_more } from 'react-icons-kit/md/ic_expand_more';
// import { ic_lens } from 'react-icons-kit/md/ic_lens';
// import { eye } from 'react-icons-kit/feather/eye';
// import { eyeOff } from 'react-icons-kit/feather/eyeOff';
// import Link from 'next/link';
// import { allRowsRequired } from '@/utils/validation';
import { useState, useEffect } from 'react';
import { nanoid } from 'nanoid';
import { useRouter } from 'next/router';

import { BuilderProvider } from '@/contexts/builder-context';
// import { BuilderMenu, BuilderEditor } from '@/components/Builder/index';
import { BuilderPageWrapper, FlexBox, ViewWrapper } from '@/styles/index';
import { initNewLocalPoll } from '@/utils/builder';
// import Tippy from '@/components/Tooltip';
import { useSession } from 'next-auth/client';
// import Navbar from '@/components/Layout/Navbar';
// import Footer from '@/components/Layout/Footer';
import HeadMeta from '@/components/HeadMeta';
import { getNewTemplate } from '@/utils/poll-templates';
import AdSenseBanner from '@/components/AdSenseBanner';
import dynamic from 'next/dynamic';

const BuilderIntro = dynamic(() => import('@/components/Builder/BuilderIntro'), { ssr: false });
const Footer = dynamic(() => import('@/components/Layout/Footer'));

const INITIAL_BASE = {
  id: nanoid(),
  lang: 'en',
  showPollTitle: true, // default true
  showStageNavigation: true, // default true
  enableGoBack: true, // default true
  stageNavigation: false, // default false
  status: 'unpublished',
  title: '',
  description: '',
  username: '', // populate with logged user
  ownerName: '',
  pages: []
};

const Create = props => {
  // console.log({ props });
  const router = useRouter();
  const [session] = useSession();
  const [model, setModel] = useState(INITIAL_BASE);
  const [loading, setLoading] = useState(true);
  const { template } = router.query;
  // console.log({ template });

  // re-render on session change
  useEffect(() => {}, [session]);

  // ––– URL PARAMS ACTIONS
  // if query tab, navigate to tab
  useEffect(() => {
    if (template) {
      // console.log('useEffect', template);
      const templateModel = getNewTemplate(template);
      setModel(templateModel);
    }
  }, [template]);

  useEffect(() => {
    const initCreateFlow = async () => {
      await initNewLocalPoll();
      await setLoading(false);
    };
    initCreateFlow();
  }, []);

  // console.log({ model });
  const isProUser = session && session.user.isProUser === 'true';
  const isPremiumUser = session && session.user.isPremiumUser === 'true';
  const isSubscriptionUser = isProUser || isPremiumUser;
  const showAds = !session || !isSubscriptionUser;

  return (
    <ViewWrapper>
      <HeadMeta title="Create New Poll – Pollme" />
      <BuilderProvider initialModel={model}>
        <BuilderPageWrapper>
          <FlexBox className="full-height">
            {!loading && <BuilderIntro baseModel={INITIAL_BASE} session={session} />}
          </FlexBox>
          {showAds && (
            <AdSenseBanner
              className="ads-block centered"
              slot="3664110702" // create footer
              format="auto"
              responsive="true"
            />
          )}
        </BuilderPageWrapper>
      </BuilderProvider>
      <Footer />
    </ViewWrapper>
  );
};

export default Create;

// export async function getServerSideProps(context) {
//   console.log('server session');
//   const session = await getSession(context);
//   console.log({ session });
//   return {
//     props: { session }
//   };
// }

// https://react-hook-form.com/api/#register
// for input rules
